'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSecurityTaggedLink = exports.warnIfShouldBeExternal = exports.getRel = exports.getTarget = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UnsafeUrl = require('./UnsafeUrl');

var _ThrowError = require('./ThrowError');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Determine the target attr for an <a>, based on the props of the link component.
var getTarget = exports.getTarget = function getTarget(external, target) {
  if (target !== undefined) {
    return target;
  }
  if (external) {
    return '_blank';
  }
  return undefined;
};

// Determine the rel attr for an <a>, based on the link component's rel prop and the target attr.
var getRel = exports.getRel = function getRel(rel, computedTarget) {
  if (rel !== undefined) {
    return rel;
  }
  if (computedTarget && computedTarget !== '_self') {
    // See https://mathiasbynens.github.io/rel-noopener/
    return 'noopener noreferrer';
  }
  return undefined;
};

var warnIfShouldBeExternal = exports.warnIfShouldBeExternal = function warnIfShouldBeExternal(external, computedTarget, componentName) {
  if (!external && computedTarget && computedTarget !== '_self') {
    _devLogger2.default.warn({
      message: componentName + ': External links should include an icon. Use `external={true}`.',
      key: 'Link: should be external'
    });
  }
};

// If the given `href` might be an XSS vector, wrap the given rendered link in <XSSTooltip> and fire
// an error.
var renderSecurityTaggedLink = exports.renderSecurityTaggedLink = function renderSecurityTaggedLink(href, renderedLink) {
  if ((0, _UnsafeUrl.isUnsafeUrl)(href)) {
    (0, _ThrowError.throwErrorAsync)(new Error('Detected XSS attempt! href="' + href + '"'));
    return _react2.default.createElement(
      _UnsafeUrl.XSSTooltip,
      null,
      renderedLink
    );
  }
  return renderedLink;
};